import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion' 
import Onboarding from './Onboarding/Onboarding'
import Tecnica from './Tecnica/Tecnica'
import Producto from './Producto/Producto'
import Caracteristicas from './Caracteristicas/Caracteristicas'
import { HomeContainer } from './HomeElements'

const Home = ({ location }) => {

    return(
        <HomeContainer>
            <AnimatePresence exitBeforeEnter>
                <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<Onboarding />} />
                    <Route path="tecnica" element={<Tecnica />} />
                    <Route path="producto" element={<Producto />} />
                    <Route path="caracteristicas" element={<Caracteristicas />} />
                </Routes>
            </AnimatePresence>
        </HomeContainer>
    )
}

export default Home